import React from 'react';
import { AlertTriangle, Bot, FileText } from 'lucide-react';

const sentimentStyles = {
  angry: 'bg-red-100 text-red-700',
  unhappy: 'bg-orange-100 text-orange-700',
  concerned: 'bg-amber-100 text-amber-700',
  neutral: 'bg-slate-100 text-slate-500',
};

function ChatListItem({ chat, isSelected, onClick, formatTime }) {
  const unread = !!chat.unread;
  const initials = (chat.phone_number || '').replace('+', '').slice(-2).toUpperCase();
  const sentiment = chat.last_sentiment || 'neutral';

  return (
    <li
      onClick={onClick}
      className={`
        flex gap-3 p-4 cursor-pointer border-b border-slate-200 transition-colors
        ${isSelected ? 'bg-rose-50 border-l-4 border-l-[#B1336E]' : 'hover:bg-slate-50'}
      `}
    >
      <div
        className={`
          w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 font-bold text-sm font-montserrat
          ${unread ? 'bg-[#B1336E] text-white' : 'bg-slate-200 text-slate-700'}
        `}
      >
        {initials || 'WA'}
      </div>

      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between gap-2 mb-1">
          <div className={`text-sm truncate font-montserrat ${unread ? 'font-bold text-slate-950' : 'font-semibold text-slate-800'}`}>
            {chat.phone_number}
          </div>
          <div className="text-xs text-slate-500 flex-shrink-0 font-montserrat">
            {formatTime(chat.updated_at)}
          </div>
        </div>

        <div className="flex items-center gap-2 mb-2">
          <div className={`text-sm truncate font-montserrat ${unread ? 'font-semibold text-slate-900' : 'text-slate-500'}`}>
            {chat.last_message || ' '}
          </div>
          {unread && <div className="w-2 h-2 rounded-full bg-[#B1336E] flex-shrink-0" />}
        </div>

        <div className="flex items-center gap-1.5 flex-wrap">
          <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium ${sentimentStyles[sentiment] || sentimentStyles.neutral}`}>
            {sentiment}
          </span>
          {chat.last_intent && (
            <span className="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-slate-100 text-slate-600">
              {chat.last_intent}
            </span>
          )}
          {chat.has_pending_draft && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-purple-100 text-purple-700">
              <FileText className="w-3 h-3" /> draft
            </span>
          )}
          {chat.is_handoff_required && (
            <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-red-100 text-red-700">
              <AlertTriangle className="w-3 h-3" /> human
            </span>
          )}
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-medium bg-emerald-50 text-emerald-700">
            <Bot className="w-3 h-3" /> {chat.ai_mode || 'draft'}
          </span>
        </div>
      </div>
    </li>
  );
}

export default ChatListItem;
